import React, { useState } from 'react';
import { FiPlus, FiList } from 'react-icons/fi';
import AddQuestion from './AddQuestion';
import ListQuestions from './ListQuestions';

const Questions: React.FC = () => {
  const [activeView, setActiveView] = useState<'list' | 'add' | 'edit'>('list');
  const [questionToEdit, setQuestionToEdit] = useState<number | null>(null);

  // Function to handle editing a question
  const handleEditQuestion = (questionId: number) => {
    setQuestionToEdit(questionId);
    setActiveView('edit');
  };

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-800">Gestione delle Domande</h2>

        <div className="mt-4 flex gap-2">
          <button
            onClick={() => setActiveView('list')}
            className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
            ${activeView === 'list'
              ? 'bg-indigo-500 text-white'
              : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
          >
            <FiList />
            Lista {/* Affichage en italien : Liste */}
          </button>
          <button
            onClick={() => setActiveView('add')}
            className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
            ${activeView === 'add'
              ? 'bg-indigo-500 text-white'
              : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
          >
            <FiPlus />
            Aggiungere {/* Affichage en italien : Ajouter */}
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        {activeView === 'list' && <ListQuestions onEditQuestion={handleEditQuestion} />}
        {activeView === 'add' && <AddQuestion setActiveView={setActiveView} />}
        {activeView === 'edit' && questionToEdit !== null && (
          <AddQuestion setActiveView={setActiveView} questionId={questionToEdit} />
        )}
      </div>
    </div>
  );
};

export default Questions;
